import i18next from 'i18next';
import api, { RELOAD, POPUP } from '../api/paidit-api';
import store from '../store';
import { prepareCheckoutData } from '../selectors';
import { pushAlert } from '../actions';
import { CHECKOUT_RESOLVED, CALC_FINAL_CHECK } from '../actions/types';
import { clearCache } from '../cache';

let currentValidationPromise = null;
let checkoutInProgress = false;

async function validateCheckout() {
    // TODO: debounce
    const promise = api({ rejectOnError: false, alertError: { type: RELOAD } }).order.validate(prepareCheckoutData(store.getState()));

    currentValidationPromise = promise;

    const data = await currentValidationPromise;

    if (currentValidationPromise !== promise) {
        return;
    }

    store.dispatch({ type: CALC_FINAL_CHECK, payload: data });

    if (data && !data.isBusinessAvailable) {
        store.dispatch(pushAlert({ type: POPUP, text: i18next.t('order.closeForOrders'), timeout: 5000 }));
    }

    currentValidationPromise = null;
}

const MESSAGE_CODE_TO_TRANSLATION_KEY = {
    orderMinimumUnfulfilled: 'order.orderMinimumNotFulfilled'
};

async function startCheckout(paymentInstructions) {
    if (checkoutInProgress) return null;

    checkoutInProgress = true;

    try {
        const order = prepareCheckoutData(store.getState());

        const result = await api().order.checkout({ ...order, paymentInstructions });

        store.dispatch({ type: CHECKOUT_RESOLVED, payload: result });

        clearCache();

        return result;
    } catch (error) {
        const messageKey = MESSAGE_CODE_TO_TRANSLATION_KEY[error.messageCode];
        const text = messageKey ? i18next.t(messageKey) : error.message;

        store.dispatch(pushAlert({ type: POPUP, text, timeout: 7000 }));

        return null;
    } finally {
        checkoutInProgress = false;
    }
}

export default {
    validateCheckout,
    startCheckout
};